import {NavSection, PathConfig, resolvePath} from "../config/navbar.config";
import {UserRole} from "../../../core/roles/roles.type";

export function findParentOfActivePath(
    sections: NavSection[],
    activePath: string,
    role: UserRole
): string | null {
    for (const section of sections) {
        for (const item of section.items) {
            if (item.children) {
                // Check if any child matches the active path
                const hasActiveChild = item.children.some(
                    child => resolvePath(child.path as PathConfig, role) === activePath
                );
                if (hasActiveChild) {
                    return item.id;
                }
            }
        }
    }
    return null;
}